import { normalizePriceLevel } from '../constants';

type PriceLevelBadgeProps = {
  value: unknown;
  t: any;
};

export default function PriceLevelBadge({ value, t }: PriceLevelBadgeProps) {
  const level = normalizePriceLevel(value);
  if (!level) return null;

  return (
    <span className="price-level-badge amenity-tooltip" data-tooltip={t[`priceLevel${level}Help`]} tabIndex={0}>
      <strong className="price-level-mark" aria-label={`${level} / 3`}>$</strong>
      <span>{t[`priceLevel${level}`]}</span>
    </span>
  );
}
